export default [{
    path: '/clientForm/:custom_form_id',
    name: 'clientForm',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/customForm/client-form-responses')
  }]
